import Vue from 'vue'
import Vuex from 'vuex'
import actions from './action'
import * as getters from './getters'
import mutations from './mutations'
import state from './state'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
const files = require.context('@/store/modules', true, /\.js$/)
let modules = {}
files.keys().forEach(key => {
  Reflect.set(modules, key.replace(/.\/|.js/g, ''), files(key).default)
})
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules,
  plugins: [
    createPersistedState({
      reducer(val) {
        return {
          authDataAndAgentSetting: val.authDataAndAgentSetting,
        }
      },
    }),
  ],
})
